import styled from '@emotion/styled';
import { Badge } from 'src/components-dummy';

export const BadgeStyled = styled(Badge)`
  margin-left: 10px;
`;
